// extracted by mini-css-extract-plugin
export default {"multiplierAdditionalInfo":"LJ9MQ0BsDBIrLGx8BVTQ"};